import { render } from "./EventCard.vue?vue&type=template&id=3b679a82&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=3b679a82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3b679a82"

export default script